import { ReactNode, FC, SetStateAction, Dispatch } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import useSettings from '../../hooks/useSettings';
import DashboardHeader from './header';
import NavbarVertical from './navbar/NavbarVertical';
import NavbarHorizontal from './navbar/NavbarHorizontal';
import { MainStyle, styles } from './styles';
import MasqueradeBack from './masquerade-back';
import useCurrentUser from '~/hooks/useCurrentUser';

type Props = {
  children: ReactNode;
  collapseClick: boolean;
  connectionName?: string;
  isCollapse?: boolean;
  isDesktop?: boolean;
  isError?: boolean;
  isLicenseNational?: boolean;
  name?: string;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  sx?: SxProps<Theme>;
  title?: string;
};

const DashboardLayout: FC<Props> = ({
  children,
  collapseClick,
  connectionName,
  isCollapse,
  isDesktop,
  isError,
  isLicenseNational,
  name,
  open,
  setOpen,
  sx,
  title,
}) => {
  const { themeLayout } = useSettings();
  const { isMasquerade } = useCurrentUser();
  const verticalLayout = themeLayout === 'vertical';

  if (verticalLayout) {
    return (
      <>
        {isDesktop ? (
          <NavbarHorizontal />
        ) : (
          <NavbarVertical
            isOpenSidebar={open}
            onCloseSidebar={() => setOpen(false)}
            isMasquerade={isMasquerade}
          />
        )}
      </>
    );
  }

  return (
    <>
      {isMasquerade && <MasqueradeBack />}
      <Box sx={{ ...sx, ...styles.box }}>
        <NavbarVertical
          isOpenSidebar={open}
          onCloseSidebar={() => setOpen(false)}
          isMasquerade={isMasquerade}
        />
        <DashboardHeader
          title={title}
          connectionName={connectionName}
          isCollapse={isCollapse}
          isError={isError}
          isLicenseNational={isLicenseNational}
          isMasquerade={isMasquerade}
          name={name}
        />
        <MainStyle collapseClick={collapseClick} isMasquerade={isMasquerade}>
          {children}
        </MainStyle>
      </Box>
    </>
  );
};

export default DashboardLayout;
